/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_67216100","_67216100",""]'><div :class='["","_67216100",""]'><div :class='["","_67216100",""]'>min-height 属性最小内容展示高度</div><div :class='["bg-white","_67216100",""]'><cube-collapse :min-height="('40px')" :class='["","_67216100",""]'><div :class='["text","_67216100",""]'>内容文案，第一行</div><div :class='["text","_67216100",""]'>内容文案，第二行</div><div :class='["text","_67216100",""]'>内容文案，第三行</div><div :class='["text","_67216100",""]'>内容文案，第四行</div><div :class='["text","_67216100",""]'>内容文案，第五行</div><div :class='["text","_67216100",""]'>内容文案，第六行</div><div :class='["text","_67216100",""]'>内容文案，第七行</div></cube-collapse></div><div :class='["item","_67216100",""]'>内容小于 min-height时，隐藏展开按钮</div><div :class='["bg-white","_67216100",""]'><cube-collapse :min-height="('100px')" :class='["","_67216100",""]'><div :class='["text","_67216100",""]'>内容文案，第一行</div><div :class='["text","_67216100",""]'>内容文案，第二行</div><div :class='["text","_67216100",""]'>内容文案，第三行</div></cube-collapse></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"scoped":true,"mid":"_67216100"}'>
.bg-white
  margin-top: 6px
  background-color: #fff
.text
  line-height: 20px
.item
  margin-top: 20px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_67216100"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_67216100"}
  /** script content **/
  require("./change-min-height.mpx.js?isComponent&outputPath=components%2Fchange-min-height67216100%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-min-height.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fchange-min-height67216100%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_67216100"],
    ctorType: "component",
    outputPath: "components/change-min-height67216100/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-collapse':getComponent(require("../../../packages/mpx-cube-ui/src/components/collapse/index.mpx?isComponent&outputPath=components%2Findex5127b398%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>